import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function TrendingList() {
  const trending = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 10);

  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 animate-slide-up">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl text-foreground-100">热门排行</h2>
          <p className="text-foreground-500 text-sm mt-1">最受观众欢迎的影片</p>
        </div>
        <Link
          to="/category/all?sort=hot"
          className="text-primary-400 text-sm hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看全部
          <div className="w-4 h-4 inline-flex items-center justify-center ml-1">
            <i className="ri-arrow-right-line"></i>
          </div>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {trending.map((movie, index) => (
          <Link
            key={movie.id}
            to={`/category/${movie.category}`}
            className="flex items-center gap-4 p-3 rounded-lg bg-background-100 hover:bg-background-200 transition-all duration-300 group cursor-pointer"
          >
            <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
              <span className={`font-heading text-lg ${
                index < 3 ? 'text-accent-500' : 'text-foreground-500'
              }`}>
                {index + 1}
              </span>
            </div>
            <div className="w-12 h-16 flex-shrink-0 rounded overflow-hidden">
              <img
                src={movie.image}
                alt={movie.title}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-foreground-100 font-medium text-sm leading-snug line-clamp-1 group-hover:text-primary-400 transition-colors">
                {movie.title}
              </h3>
              <p className="text-foreground-600 text-xs mt-1">
                {movie.category === 'scifi' ? '科幻' :
                 movie.category === 'action' ? '动作' :
                 movie.category === 'comedy' ? '喜剧' :
                 movie.category === 'romance' ? '爱情' :
                 movie.category === 'horror' ? '恐怖' :
                 movie.category === 'animation' ? '动画' :
                 movie.category === 'documentary' ? '纪录' : '电视剧'}
                {' · '}{movie.year}
              </p>
            </div>
            <div className="flex items-center gap-1 flex-shrink-0">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-primary-500 text-xs"></i>
              </div>
              <span className="text-primary-400 text-sm font-medium">{movie.rating}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}